import './main';
import * as mapboxgl from 'mapbox-gl';

import alumniCsv from '../data/alumni.csv';

// eslint-disable-next-line no-import-assign, max-len
mapboxgl.accessToken = 'pk.eyJ1Ijoic2hpcmxleWthYmlyIiwiYSI6ImNqaTF2Y3ZncDFoemUzcW51dXdvYjcyZHUifQ.Nxod4xaAg4vDcHML37whwg';

const map = new mapboxgl.Map({
  container: 'map',
  style: 'mapbox://styles/shirleykabir/cjllpt32j45kp2rmr2knvpgus',
  center: [-60, 29.8283],
  zoom: 2.2,
});

/**
 * Loads local image file and returns the path.
 *
 * @param {string} alumName - name of image file for alum in static/subteams/alumni
 * @returns {any} - loaded image path
 */
function getAlumniImageUri(alumName) {
  return require(`../static/subteams/alumni/${alumName}.jpg`).default;
}

d3.csv(alumniCsv, function (data) {
  data.forEach(function (alum) {
    // create the popup
    const popup = new mapboxgl.Popup({
      offset: 25,
    })
      .setHTML(`
        <div class='alumni-popup'>
          <h6> ${alum['first-name']  } ${  alum['last-name']  } </h6>
          <p><b> ${  alum.current  } </b></p>
          <p>${  alum.position}</p>
        </div>
      `);

    // create DOM element for the marker
    const el = document.createElement('div');
    el.className = 'alum-marker';
    const alumImageSrc = getAlumniImageUri(alum['img-src']);
    el.style.backgroundImage = `linear-gradient(black, black), url(${ alumImageSrc })`;

    el.style.cursor = 'pointer';
    el.onclick = function () {
      map.flyTo({
        center: [alum.lng, alum.lat],
        zoom: 12,
        speed: 5,
        curve: 1,
        easing(t) {
          return t;
        },
      });
    };

    // create the marker
    new mapboxgl.Marker(el)
      .setLngLat([alum.lng, alum.lat])
      .setPopup(popup) // sets a popup on this marker
      .addTo(map);

  });
});

/** Zooms out to the original map center. */
function zoomOut() {
  map.flyTo({
    center: [-60, 29.8283],
    zoom: 2.2,
    speed: 5,
    curve: 1,
    easing(t) {
      return t;
    },
  });
}

const zoomOutButton = document.getElementById('return');

zoomOutButton.addEventListener('click', zoomOut);
